module.exports = __webpack_public_path__ + "static/raleway-latin-700-01a273e07cf0950b760ee6cd9540a72f.woff2";